// CognitiveOS Mock Data

// The 10 Cognitive Lanes - Definitive Color System
export const COGNITIVE_LANES = [
  { id: 'vision', name: 'Vision & Expansion', color: '#38BDF8' },       // Sky Blue
  { id: 'strategy', name: 'Strategy & Architecture', color: '#1E3A5F' }, // Deep Navy
  { id: 'creative', name: 'Creative', color: '#A855F7' },              // Vibrant Purple
  { id: 'marketing', name: 'Marketing', color: '#FB923C' },            // Coral Orange
  { id: 'operations', name: 'Operations', color: '#22C55E' },           // Forest Green
  { id: 'execution', name: 'Execution', color: '#14B8A6' },            // Dark Teal
  { id: 'revenue', name: 'Revenue', color: '#EAB308' },                 // Gold
  { id: 'relationships', name: 'Relationships', color: '#F472B6' },   // Warm Rose
  { id: 'culture', name: 'Culture', color: '#C4B5FD' },               // Soft Lavender
  { id: 'finance', name: 'Finance & Analysis', color: '#64748B' },    // Steel Blue
];

// The 4 Cognitive Levels
export const COGNITIVE_LEVELS = [
  { id: 'L1', name: 'L1 — DO', description: 'Execution level' },
  { id: 'L2', name: 'L2 — RUN', description: 'Process management' },
  { id: 'L3', name: 'L3 — IMPROVE', description: 'Optimization & analysis' },
  { id: 'L4', name: 'L4 — DECIDE + LEAD', description: 'Strategic decisions' }
];

// Task Status Values
export const TASK_STATUS = ['Planned', 'Active', 'In Review', 'Completed'];

export const teamMembers = [
  {
    id: 'tm1',
    name: 'Sarah Chen',
    title: 'Head of Product',
    bio: 'Strategic thinker with 10+ years in product leadership',
    lane_proficiency: {
      vision: 'L4',
      strategy: 'L4',
      creative: 'L3',
      operations: 'L2'
    },
    max_task_load: 8,
    current_load: 6,
    strength_notes: 'Excels at strategic planning and vision setting',
    avatar: 'SC'
  },
  {
    id: 'tm2',
    name: 'Marcus Rivera',
    title: 'Engineering Lead',
    bio: 'Full-stack architect passionate about scalable systems',
    lane_proficiency: {
      strategy: 'L3',
      execution: 'L4',
      operations: 'L4',
      finance: 'L2'
    },
    max_task_load: 10,
    current_load: 8,
    strength_notes: 'Deep technical expertise, process-driven',
    avatar: 'MR'
  },
  {
    id: 'tm3',
    name: 'Emma Thompson',
    title: 'Creative Director',
    bio: 'Award-winning designer with brand strategy background',
    lane_proficiency: {
      creative: 'L4',
      marketing: 'L4',
      vision: 'L3',
      relationships: 'L3'
    },
    max_task_load: 6,
    current_load: 5,
    strength_notes: 'Exceptional visual storytelling and brand development',
    avatar: 'ET'
  },
  {
    id: 'tm4',
    name: 'David Park',
    title: 'Operations Manager',
    bio: 'Process optimization specialist',
    lane_proficiency: {
      operations: 'L4',
      execution: 'L3',
      finance: 'L3',
      culture: 'L2'
    },
    max_task_load: 12,
    current_load: 5,
    strength_notes: 'Builds efficient systems and manages execution',
    avatar: 'DP'
  },
  {
    id: 'tm5',
    name: 'Aisha Patel',
    title: 'Chief Revenue Officer',
    bio: 'Revenue growth strategist with enterprise sales expertise',
    lane_proficiency: {
      revenue: 'L4',
      relationships: 'L4',
      strategy: 'L3',
      marketing: 'L3'
    },
    max_task_load: 8,
    current_load: 7,
    strength_notes: 'Closes enterprise deals, builds strategic partnerships',
    avatar: 'AP'
  },
  {
    id: 'tm6',
    name: 'James Liu',
    title: 'VP of Finance',
    bio: 'Financial strategist with M&A and fundraising experience',
    lane_proficiency: {
      finance: 'L4',
      strategy: 'L4',
      operations: 'L3',
      vision: 'L2'
    },
    max_task_load: 7,
    current_load: 4,
    strength_notes: 'Financial modeling, investor relations, budget optimization',
    avatar: 'JL'
  },
  {
    id: 'tm7',
    name: 'Lisa Chen',
    title: 'Marketing Manager',
    bio: 'Data-driven marketer with growth hacking expertise',
    lane_proficiency: {
      marketing: 'L3',
      creative: 'L2',
      revenue: 'L2',
      relationships: 'L2'
    },
    max_task_load: 8,
    current_load: 3,
    strength_notes: 'Expert in digital campaigns and customer acquisition',
    avatar: 'LC'
  },
  {
    id: 'tm8',
    name: 'Michael Johnson',
    title: 'Senior Developer',
    bio: 'Backend specialist with DevOps expertise',
    lane_proficiency: {
      execution: 'L3',
      operations: 'L3',
      strategy: 'L2',
      finance: 'L1'
    },
    max_task_load: 10,
    current_load: 7,
    strength_notes: 'Reliable delivery, strong debugging skills',
    avatar: 'MJ'
  },
  {
    id: 'tm9',
    name: 'Rachel Kim',
    title: 'UX Designer',
    bio: 'User experience advocate with research background',
    lane_proficiency: {
      creative: 'L3',
      relationships: 'L3',
      vision: 'L2',
      marketing: 'L2'
    },
    max_task_load: 7,
    current_load: 6,
    strength_notes: 'Deep user empathy, prototype specialist',
    avatar: 'RK'
  },
  {
    id: 'tm10',
    name: 'Carlos Mendez',
    title: 'Culture Lead',
    bio: 'People operations expert with coaching background',
    lane_proficiency: {
      culture: 'L4',
      relationships: 'L4',
      operations: 'L2',
      vision: 'L2'
    },
    max_task_load: 8,
    current_load: 5,
    strength_notes: 'Team engagement, conflict resolution, onboarding',
    avatar: 'CM'
  }
];

export const projects = [
  {
    id: 'p1',
    name: 'Platform Redesign 2025',
    description: 'Complete UX overhaul and technical modernization',
    project_lead: 'tm1',
    status: 'on-track',
    created_at: '2025-01-15T10:00:00Z',
    completion_percentage: 42,
    active_tasks: 8,
    overdue_steps: 2,
    overdue_phases: 0,
    on_time_rate: 0.89
  },
  {
    id: 'p2',
    name: 'Enterprise Sales Expansion',
    description: 'Build enterprise go-to-market strategy and sales infrastructure',
    project_lead: 'tm3',
    status: 'focus-required',
    created_at: '2025-02-01T10:00:00Z',
    completion_percentage: 28,
    active_tasks: 12,
    overdue_steps: 5,
    overdue_phases: 1,
    on_time_rate: 0.71
  },
  {
    id: 'p3',
    name: 'Q2 Infrastructure Migration',
    description: 'Move core services to new cloud architecture',
    project_lead: 'tm2',
    status: 'on-track',
    created_at: '2025-03-10T10:00:00Z',
    completion_percentage: 15,
    active_tasks: 6,
    overdue_steps: 0,
    overdue_phases: 0,
    on_time_rate: 0.95
  }
];

export const tasks = [
  {
    id: 't1',
    project_id: 'p1',
    title: 'Conduct user interviews with 15 enterprise customers',
    description: 'Deep-dive interviews to understand pain points and feature needs',
    primary_lane: 'relationships',
    required_level: 'L2',
    supporting_lanes: ['marketing', 'vision'],
    status: 'Active',
    due_date: '2025-07-20T23:59:59Z',
    definition_of_success: 'Complete 15 interviews, synthesize insights into actionable recommendations',
    owner_id: 'tm3',
    contributors: ['tm1']
  },
  {
    id: 't2',
    project_id: 'p1',
    title: 'Build component library foundation',
    description: 'Create reusable React components with Storybook documentation',
    primary_lane: 'execution',
    required_level: 'L2',
    supporting_lanes: ['creative'],
    status: 'Active',
    due_date: '2025-07-25T23:59:59Z',
    definition_of_success: '30+ documented components, 90% test coverage, deployed to staging',
    owner_id: 'tm2',
    contributors: ['tm3', 'tm4']
  },
  {
    id: 't3',
    project_id: 'p1',
    title: 'Enterprise pricing strategy overhaul',
    description: 'Redesign pricing tiers, negotiate volume discounts, and create ROI calculators for sales team',
    primary_lane: 'revenue',
    required_level: 'L3',
    supporting_lanes: ['strategy', 'finance', 'marketing', 'relationships'],
    status: 'Active',
    due_date: '2025-08-15T23:59:59Z',
    definition_of_success: 'New pricing model approved by leadership, sales enablement materials ready, 3 pilot customers onboarded',
    owner_id: 'tm1',
    contributors: ['tm2', 'tm3', 'tm4', 'tm5']
  },
  {
    id: 't4',
    project_id: 'p1',
    title: 'Cross-functional product launch campaign',
    description: 'Coordinate go-to-market strategy across all departments for Q3 product release',
    primary_lane: 'marketing',
    required_level: 'L4',
    supporting_lanes: ['creative', 'revenue', 'operations', 'relationships', 'vision'],
    status: 'Active',
    due_date: '2025-09-01T23:59:59Z',
    definition_of_success: 'Launch event executed, 50+ media mentions, 1000 new signups in first week',
    owner_id: 'tm3',
    contributors: ['tm1', 'tm2', 'tm4', 'tm5', 'tm6']
  },
  {
    id: 't5',
    project_id: 'p2',
    title: 'Global infrastructure resilience program',
    description: 'Implement multi-region failover, disaster recovery protocols, and 99.99% uptime guarantees',
    primary_lane: 'operations',
    required_level: 'L4',
    supporting_lanes: ['execution', 'strategy', 'finance'],
    status: 'Active',
    due_date: '2025-10-01T23:59:59Z',
    definition_of_success: 'Zero unplanned downtime, automated failover tested, compliance certifications obtained',
    owner_id: 'tm2',
    contributors: ['tm1', 'tm4', 'tm5', 'tm6']
  },
  {
    id: 't6',
    project_id: 'p1',
    title: 'Company culture transformation initiative',
    description: 'Define core values, implement recognition programs, and establish cross-team collaboration rituals',
    primary_lane: 'culture',
    required_level: 'L3',
    supporting_lanes: ['relationships', 'vision', 'operations', 'creative'],
    status: 'Active',
    due_date: '2025-08-30T23:59:59Z',
    definition_of_success: 'Employee NPS improved by 20 points, 95% participation in culture programs',
    owner_id: 'tm4',
    contributors: ['tm1', 'tm3', 'tm5', 'tm6']
  },
  {
    id: 't7',
    project_id: 'p2',
    title: 'Strategic partnership expansion',
    description: 'Identify, negotiate, and onboard 5 new technology integration partners for ecosystem growth',
    primary_lane: 'relationships',
    required_level: 'L4',
    supporting_lanes: ['revenue', 'strategy', 'marketing', 'execution'],
    status: 'Active',
    due_date: '2025-09-15T23:59:59Z',
    definition_of_success: '5 signed partnership agreements, integration documentation complete, joint marketing plan',
    owner_id: 'tm1',
    contributors: ['tm2', 'tm3', 'tm4', 'tm6']
  },
  {
    id: 't8',
    project_id: 'p1',
    title: 'Financial modeling and investor reporting automation',
    description: 'Build automated dashboards, predictive models, and board-ready reporting infrastructure',
    primary_lane: 'finance',
    required_level: 'L3',
    supporting_lanes: ['operations', 'strategy', 'execution'],
    status: 'In Review',
    due_date: '2025-07-30T23:59:59Z',
    definition_of_success: 'Real-time financial dashboards, monthly investor reports automated, 50% reduction in reporting time',
    owner_id: 'tm4',
    contributors: ['tm1', 'tm2', 'tm5', 'tm6']
  },
  {
    id: 't9',
    project_id: 'p2',
    title: 'Brand identity evolution and market positioning',
    description: 'Refresh visual identity, messaging framework, and competitive differentiation strategy',
    primary_lane: 'creative',
    required_level: 'L4',
    supporting_lanes: ['marketing', 'vision', 'strategy', 'relationships', 'revenue'],
    status: 'Active',
    due_date: '2025-08-20T23:59:59Z',
    definition_of_success: 'New brand guidelines launched, 100% asset migration complete, positive market reception',
    owner_id: 'tm3',
    contributors: ['tm1', 'tm2', 'tm4', 'tm5']
  }
];

export const phases = [
  {
    id: 'ph1',
    task_id: 't1',
    title: 'Define',
    lane: 'strategy',
    level: 'L3',
    assignee: 'tm3',
    due_date: '2025-07-01T23:59:59Z',
    deliverable: 'Interview guide and participant selection criteria',
    status: 'Completed',
    order: 1
  },
  {
    id: 'ph2',
    task_id: 't1',
    title: 'Execute Interviews',
    lane: 'relationships',
    level: 'L2',
    assignee: 'tm1',
    due_date: '2025-07-15T23:59:59Z',
    deliverable: 'Recorded and transcribed interviews',
    status: 'Active',
    order: 2
  }
];

export const orgMetrics = {
  execution_momentum: 'Building',
  velocity_this_week: 12,
  velocity_last_week: 9,
  on_time_phase_rate: 0.87,
  active_momentum_count: 15,
  needing_attention_count: 7
};
